<script>
  // import windowOpenPdf from "@utils/window-open-pdf";
  // import pdf from 'vue-pdf'
  // import vueshowpdf from 'vueshowpdf'

  export default {
    components: {
      // pdf,
      // vueshowpdf
    },
    data() {
      return {
        media: null,
        // numPages: undefined,
        // isshowpdf: false
      }
    },
    mounted() {
      this.tryToFetchFile()
    },
    methods: {
      async tryToFetchFile() {
        // https://stackoverflow.com/questions/21729451/pdf-blob-pop-up-window-not-showing-content

        // https://blog.csdn.net/weixin_42678675/article/details/109736497
        this.$store.dispatch('global/fetchFile', {
          url: `/file/download/${ this.$route.params.mediaUuid }`,
          // responseType: 'arraybuffer'
          responseType: 'blob'
        })
          .then((response) => {
            this.media = URL.createObjectURL(response);
            // this.isshowpdf = true
            /* const loadingTask = pdf.createLoadingTask(this.media);

             loadingTask.promise.then(pdf => {
             this.numPages = pdf.numPages;
             }); */
          })
          .catch(() => {
            this.$router.replace({ name: '404' })
          })

        // windowOpenPdf(response)

        /* var file = new Blob([data], {type: 'application/pdf'});
         var fileURL = URL.createObjectURL(file);
         window.open(fileURL); */
      }
    }
  }
</script>
<template>
  <div>
    <!--<pdf :src="media"/>-->
    <!--<pdf
      v-for="i in numPages"
      :key="i"
      :src="media"
      :page="i"
      style="display: inline-block; width: 100%"
    ></pdf>-->
    <!--<vueshowpdf
      v-model="isshowpdf"
      :pdfurl="media"
      :maxscale='4'
      :minscale='0.6'
      :scale='1.1'
    />-->
    <embed :src="media" type='application/pdf' style="width: 100%;height: 100vh"/>
  </div>
</template>
